<!-- 单图上传控件 -->
<template>
	<div class="single-upload">
		<div @click="showSelectForm">
			<img v-if="imageUrl" :src="imageUrl" :class="props.class" />
			<el-icon v-else class="avatar-uploader-icon"><plus /></el-icon>
		</div>
	</div>
	<!--弹窗 Start-->
	<el-dialog ref="dialogSelectFormRef" title="图片设置" v-model="dialogSelectFormVisible" width="600px" draggable append-to-body>
		<div style="display: grid">
			<div v-show="fileList.length > 0">
				<el-divider content-position="left"><span class="divider-small">从图集选择：</span></el-divider>
				<el-row :gutter="35">
					<el-col :xs="24" :sm="5" :md="5" :lg="5" :xl="5" v-for="i in fileList">
						<img class="el-upload-list__item-thumbnail thumbnail" :src="i.url" alt="" />
						<div style="width: 100%; text-align: center">
							<span class="set" @click="onSetMainImage(i.url)">设为主图片</span>
						</div>
					</el-col>
				</el-row>
			</div>
			<el-divider content-position="left"><span class="divider-small">图片上传</span></el-divider>
			<p class="uptip">可点击图片上传</p>
			<!-- 单图上传控件 -->
			<div class="single-upload">
				<el-upload
					class="avatar-uploader"
					:data="additionalData"
					:headers="headers"
					:action="uploadImgUrl"
					:before-upload="handleBeforeUpload"
					:on-success="handleUploadSuccess"
					:show-file-list="false">
					<img v-if="imageUrl" :src="imageUrl" class="thumbnail" style="border: var(--el-border); margin-right: 5px" />
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</div>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button @click="onClose()">关闭</el-button>
			</div>
		</template>
	</el-dialog>
	<!--弹窗 End-->
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getToken } from '@/utils/auth'
import { checkFileUpload } from '@/utils/scm'
import { useImageUrl } from '@/utils/dynamic'
import defaultSettings from '@/settings'
import defaultImgs from '@/images'

const emit = defineEmits(['change', 'update:modelValue'])

const props = defineProps({
	// 父组件 v-model 没有指定参数名，则默认是 modelValue
	modelValue: [String, Object, Array],
	// 大小限制(MB)
	fileSize: {
		type: Number,
		default: 5
	},
	// 文件类型, 例如['png', 'jpg', 'jpeg']
	fileType: {
		type: Array,
		default: () => ['png', 'jpg', 'jpeg', 'gif']
	},
	class: {
		type: String,
		default: 'avatar'
	},
	//图集
	images: {
		type: String,
		default: ''
	}
})

const uploadImgUrl = ref(defaultSettings.fileUploadUrl) // 上传的图片服务器地址
const imageUrl = ref(props.modelValue || defaultImgs.defaultImg)
const additionalData = ref({
	belongApp: defaultSettings.app,
	belongAppId: defaultSettings.appId
})

const headers = ref({ Authorization: 'Bearer ' + getToken() })
const fileList = ref([])
const dialogSelectFormVisible = ref(false) // 弹窗

//使用 before-upload 限制用户上传的图片格式和大小
const handleBeforeUpload = (file) => {
	return checkFileUpload(file, props.fileType, props.fileSize)
}

//上传成功, 数据双向绑定
const handleUploadSuccess = (res, files) => {
	if (res && res.ResData) {
		imageUrl.value = res.ResData.FilePath
		emit('update:modelValue', imageUrl.value)
	} else {
		ElMessage.error(res.ErrMsg)
	}
}

//显示弹窗
const showSelectForm = () => {
	let val = props.images
	if (val != null && val != []) {
		// 首先将值转为数组
		let list = Array.isArray(val) ? val : val.split(',')
		// 然后将数组转为对象数组
		fileList.value = list.map((item) => {
			if (typeof item === 'string') {
				//显示时加路径
				return { name: item, url: item }
			}
		})
	}
	dialogSelectFormVisible.value = true
}

const onClose = () => {
	dialogSelectFormVisible.value = false
}
//设为主图
const onSetMainImage = (url) => {
	imageUrl.value = url
	emit('update:modelValue', imageUrl.value)
}
// 因为props.modelValue是非引用类型，改变时，需要监听，对响应式数据重新赋值
watch(
	() => props.modelValue,
	(val) => {
		if (val != null && val != undefined && val != '' && val != []) {
			//如果是远程文件则直接赋值
			imageUrl.value = useImageUrl(val)
		} else if (imageUrl.value != null && imageUrl.value != '') {
			emit('update:modelValue', imageUrl.value)
		}
	},
	{
		immediate: true,
		deep: true
	}
)
</script>

<style scoped lang="scss">
.set {
	font-size: 11px !important;
	color: #409eff;
	cursor: pointer;
}
.uptip {
	color: #bbb;
	font-size: 10px;
	padding-left: 20px;
}
.thumbnail {
	width: 100px;
	height: 100px;
}
</style>
